import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { DossierSection } from "../components/DossierSection";
import { BioHackAd } from "../components/BioHackAd";
import { Footer } from "../components/Footer";
import { HallOfFame } from "../components/HallOfFame";
import { DolosNightBanner } from "../components/DolosNightBanner";
import { GameAd } from "../components/GameAd";
import { HeroSection } from "../components/HeroSection";
import { Marquee } from "../components/Marquee";
import { NewsletterSection } from "../components/NewsletterSection";
import { CourierJobBoard } from "../components/CourierJobBoard";
import { RunnerRoster } from "../components/RunnerRoster";
import { RiotballAd } from "../components/RiotballAd";
import { IsmAd } from "../components/IsmAd";
import { PanelPreview } from "../components/PanelPreview";
import { StoreBanner } from "../components/StoreBanner";
import { RecruitmentBanner } from "../components/RecruitmentBanner";
import { SagaSection } from "../components/SagaSection";
import { SandWormAd } from "../components/SandWormAd";
import { TcgSection } from "../components/TcgSection";
import { WantedBreak } from "../components/WantedBreak";
import { HighwayBanner } from "../components/HighwayBanner";
import { AllianceSponsorsBanner } from "../components/AllianceSponsorsBanner";
import { CritterBanner } from "../components/CritterBanner";
import { GamesHub } from "../components/GamesHub";
import { RiotballLeagueStrip } from "../components/RiotballLeagueStrip";
import { scrollToSection } from "../data/site";

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    if (!location.state?.scrollTo) return;
    const timer = window.setTimeout(() => scrollToSection(location.state.scrollTo), 120);
    return () => window.clearTimeout(timer);
  }, [location.state]);

  return (
    <main className="home-page" data-testid="home-page">
      <HeroSection />
      <GamesHub />
      <SagaSection />
      <PanelPreview />
      <StoreBanner />
      <section className="tcg-arena-banner-wrap" data-testid="tcg-arena-banner-section">
        <Link to="/tcg?mode=battle" className="tcg-arena-banner" data-testid="tcg-arena-banner" aria-label="Enter the TCG Battle Arena">
          <img loading="lazy" src="/assets/tcg-arena-banner.jpg" alt="Dolo's Wasteland Runner TCG — The Pandarmor Chronicles, Year 2355" />
          <span className="tcg-arena-banner-cta">ENTER THE BATTLE ARENA →</span>
        </Link>
      </section>
      <TcgSection />
      <Marquee />
      <RiotballLeagueStrip />
      <RunnerRoster />
      <GameAd />
      <DolosNightBanner />
      <HighwayBanner />
      <CritterBanner />
      <section className="dolo-bingo-banner-wrap" data-testid="dolo-bingo-banner-section">
        <Link to="/dolopals#dolo-bingo" className="dolo-bingo-home-banner" data-testid="dolo-bingo-home-banner" aria-label="Enter Dolo Bingo">
          <div className="dolo-bingo-hexes" aria-hidden="true">
            {["D", "O", "L", "O", "S"].map((letter, index) => <i key={`${letter}-${index}`}>{letter}</i>)}
          </div>
          <div className="dolo-bingo-copy">
            <strong>DOLO BINGO</strong>
            <span>CALLER GRID LIVE — MATCH THE CODE BEFORE TIMEOUT</span>
          </div>
          <em>ENTER BINGO →</em>
        </Link>
      </section>
      <section className="album-unlock-banner-wrap" data-testid="album-unlock-banner-section">
        <Link to="/wasteland-radio#radioactive-dust-drop" className="album-unlock-banner" data-testid="album-unlock-home-banner" aria-label="Win the Radioactive Dust album by earning points" style={{ backgroundImage: "linear-gradient(90deg, rgba(2,7,13,0.58) 0%, rgba(11,17,24,0.30) 52%, rgba(16,8,3,0.45) 100%), url('/assets/radioactive-dust-band-bg.webp')" }}>
          <div className="album-unlock-copy">
            <span>OFFICIAL SUPPLY DROP</span>
            <strong>WIN THIS ALBUM BY EARNING POINTS</strong>
            <p>RADIOACTIVE DUST — UNLOCK WITH 10,000+ PTS OR PURCHASE FOR $5</p>
          </div>
          <em>UNLOCK NOW →</em>
        </Link>
      </section>
      <section className="dolopals-banner-wrap" data-testid="dolopals-banner-section">
        <Link to="/dolopals#adopt-a-tiny-titan" className="dolopals-home-banner" data-testid="dolopals-home-banner" aria-label="Adopt a Tiny Titan in the DoloPals KidZone">
          <img loading="lazy" src="/assets/dolopals-home-banner.webp" alt="DoloPals Tiny Titans — collect them all" />
          <span className="dolopals-banner-cta">ENTER FOR DAILY DROPS →</span>
        </Link>
      </section>
      <WantedBreak />
      <SandWormAd />
      <BioHackAd />
      <RecruitmentBanner />
      <DossierSection />
      <CourierJobBoard />
      <NewsletterSection />
      <RiotballAd />
      <IsmAd />
      <HallOfFame />
      <section className="alliance-banner-wrap" data-testid="alliance-banner-section">
        <AllianceSponsorsBanner />
      </section>
      <Footer />
    </main>
  );
}
